"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadRequestError = void 0;
const CustomError_1 = require("./CustomError");
class BadRequestError extends CustomError_1.CustomError {
    constructor(errors, statusCode = 400) {
        super('Bad Request Error');
        this.errors = errors;
        this.success = false;
        this.getErrors = () => this.errors.map((err) => ({
            message: err.msg,
            field: err.loc.toString(),
        }));
        this.serializeErrors = () => this.getErrors()
            .map((err) => `[<${err.field}> ${err.message}]`)
            .toString();
        this.errors = errors;
        this.statusCode = statusCode;
        Object.setPrototypeOf(this, BadRequestError.prototype);
    }
}
exports.BadRequestError = BadRequestError;
//# sourceMappingURL=BadRequestError.js.map